import SearchImage from './searchIcon.svg'
import bell from './bell.svg'
import AppNavigationArrow from './AppNavigationArrow.svg'

export const searchIcon = SearchImage
export const BellWhiteIcon = bell
export const AppNavigationArrowIcon = AppNavigationArrow
